import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTenant } from "../context/TenantContext.jsx";
import { resolveActiveTenant } from "../utils/companyIdentifier";

/**
 * AdminRoute Component
 * Restricts access to admin-only routes based on userInfo.isAdmin
 * Redirects non-admin users to the tenant-aware spaces page
 */
const AdminRoute = () => {
  const { userInfo } = useSelector((state) => state.user);
  const { tenantName, hasTenant } = useTenant();
  const location = useLocation();

  // Wait until userInfo is loaded before making redirect decisions
  if (!userInfo?.userId && !userInfo?.email) {
    return null;
  }

  if (!userInfo?.isAdmin) {
    // Context, then the current URL, then the identifier stored at login
    const activeTenant = resolveActiveTenant({ tenantName, hasTenant, pathname: location.pathname, targetPath: "/app/dashboard" });

    const redirectPath = activeTenant
      ? `/${activeTenant}/app/dashboard`
      : "/app/dashboard";

    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
